<template>
  <div class="w-full h-screen flex">
    <div
      class="bg-white p-6 sm:p-8 md:p-12 overflow-auto z-40 text-center flex flex-col flex-1 justify-start w-screen"
      :class="containerClass"
    >
      <div class="flex items-center justify-center mb-6 xl:mb-12">
        <img
          src="/images/apc-logo.png"
          alt="APC UK Logo"
          class="h-8 xl:h-10 mr-6"
        />
        <img
          src="/images/zenzic-logo.png"
          alt="Zenzic Logo"
          class="h-6 xl:h-8"
        />
      </div>
      <h1 class="font-light text-4xl mb-6 xl:hidden">
        {{ $config.name }}
      </h1>
      <slot />
      <div class="mt-auto">
        <p class="text-center mt-6 text-xs text-grey-500">
          <a href="/privacy-policy" class="no-underline">Privacy policy</a> |
          <a href="/terms-conditions" class="no-underline">
            Terms &amp; Conditions
          </a>
        </p>
      </div>
    </div>
    <div class="app-gradient flex-1 hidden xl:flex items-center">
      <slot name="panel">
        <div class="container mx-auto text-white px-24">
          <h1 class="text-4xl xxl:text-7xl font-light">
            {{ $config.name }}
          </h1>
          <p class="text-base xxl:text-2xl">
            {{ $config.description }}
          </p>
          <hr class="border-t-2 border-white opacity-50 my-6 xxl:my-12" />
          <div class="flex items-center">
            <a
              href="https://www.apcuk.co.uk?utm_source=mobilise.apc&utm_medium=footer&utm_campaign=mobilise-programme"
              target="_blank"
              rel="noopener"
            >
              <img
                src="/images/apc-logo-white.png"
                alt="APC UK Logo"
                class="h-12 xxl:h-16 mr-6 xxl:mr-12 hover:opacity-50"
              />
            </a>
            <a
              href="https://zenzic.io?utm_source=mobilise.apc&utm_medium=footer&utm_campaign=mobilise-programme"
              target="_blank"
              rel="noopener"
            >
              <img
                src="/images/zenzic-logo-white.png"
                alt="Zenzic Logo"
                class="h-6 xxl:h-10 hover:opacity-50"
              />
            </a>
          </div>
        </div>
      </slot>
    </div>
    <app-cookie />
  </div>
</template>

<script>
export default {
  name: "AuthLayout",
  props: {
    containerClass: {
      type: String,
      required: false,
      default() {
        return "xl:max-w-sm";
      }
    }
  }
};
</script>

<style>
.app-gradient {
  background: config("colors.primary-100");
  background: linear-gradient(
    45deg,
    config("colors.primary-500") 70%,
    config("colors.secondary-500") 100%
  );
}
</style>
